import Cookies from 'js-cookie';
import * as actionTypes from '../constants/recentlyViewedConstants';
import axios from 'axios';

export const addProductToRecentlyViewed = (productId) => async (dispatch) => {
    try {
      dispatch({ type: actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_REQUEST });
      const token = Cookies.get("uaTfl");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await axios.post("/api/v1/add-to-recently-viewed", { productId }, config);
      if (res.status === 201) {
        const { product } = res.data; // Assuming the response contains the added product
        dispatch({
          type: actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_SUCCESS,
          payload: { product }, // Pass the added product as payload
        });
      } else {
        const { error } = res.data;
        dispatch({
          type: actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_FAIL,
          payload: error,
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.ADD_PRODUCT_TO_RECENTLY_VIEWED_FAIL,
        payload: error.message,
      });
    }
  };
  
  export const getRecentlyViewedProducts = () => async (dispatch) => {
    try {
      dispatch({ type: actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_REQUEST });
      const token = Cookies.get("uaTfl");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const res = await axios.get("/api/v1/recently-viewed", config);
      if (res.status === 200) {
        const { recentlyViewedProducts } = res.data;
        dispatch({
          type: actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_SUCCESS,
          payload: recentlyViewedProducts,
        });
      } else {
        const { error } = res.data;
        dispatch({
          type: actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_FAIL,
          payload: error,
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.GET_RECENTLY_VIEWED_PRODUCTS_FAIL,
        payload: error.message,
      });
    }
  };